export default window.SEEK_CONFIG;
